import { defineMessages } from 'react-intl';

const messages = defineMessages({
  brothersAssignedOfRequired: {
    id: 'app.containers.RouteAssignment.CandidateAssignment.brothersAssignedOfRequired',
    defaultMessage: 'Brothers: {assigned} / {required}',
  },
});

export default messages;
